import { Injectable } from '@angular/core';
import { RouteService, StorageService } from '../services';
import { ActivatedRouteSnapshot } from '@angular/router';
import { objectToCamel } from 'ts-case-convert';
import { IService } from 'src/app/models';
import { initialPaginationState } from '../store/initialisation/pagination';
import { initialServicesState } from '../store/initialisation/services';

@Injectable({
  providedIn: 'root',
})
export class RoutesResolver {

  constructor(private routeService: RouteService, public storageService: StorageService) {}

  async resolve(route: ActivatedRouteSnapshot, serviceInfos: number[], explicitPage?: number) {
    this.storageService.setRouteName('services');
    // An explicit page (eg. from a pagination click) always wins - the URL's routesPage
    // query param may not have finished updating yet (router.navigate is async), so trusting
    // it here would race and re-fetch the previous page. Fall back to the URL for fresh/direct
    // navigation (deep links), then to data.
    let page: number;
    if (explicitPage && explicitPage > 0) {
      page = explicitPage;
    } else {
      const pageParam = route.queryParamMap.get('routesPage');
      const pageFromUrl = pageParam ? Number(pageParam) : null;
      page = (pageFromUrl && !isNaN(pageFromUrl) && pageFromUrl > 0)
        ? pageFromUrl
        : (route.data['routes']?.pagination.actualPage || 1);
    }
    const size = route.data['routes']?.pagination.numberOfElements || 5;

    const {
      content,
      number_of_elements,
      total_elements,
      total_pages,
      first,
      last,
    } = await this.routeService.getRoutesByServiceInfo(serviceInfos, page, size);

    return this.getData(
      content,
      number_of_elements,
      total_elements,
      total_pages,
      first,
      last,
      page,
    );
  }

  async getRoutesSearch(
    route: ActivatedRouteSnapshot,
    serviceInfos: number[],
    searchValue?: string
  ) {
    const page = route.data['routes']?.pagination.actualPage || 1;
    const size = route.data['routes']?.pagination.numberOfElements || 5;

    const {
      content,
      number_of_elements,
      total_elements,
      total_pages,
      first,
      last,
    } = await this.routeService.getRoutesSearch(serviceInfos, page, size, searchValue)
    return this.getData(
      content,
      number_of_elements,
      total_elements,
      total_pages,
      first,
      last,
      page,
    );
  }

  getData(
    content: any,
    number_of_elements: any,
    total_elements: any,
    total_pages: any,
    first: any,
    last: any,
    page: any,
  ) {
    const data = {...initialServicesState};
    data.value = objectToCamel(content) as Array<IService>;
    data.isFetchingServices = false;
    data.pagination = {...initialPaginationState};
    data.pagination.numberOfElements = number_of_elements;
    data.pagination.totalPages = total_pages;
    data.pagination.totalElements = total_elements;
    data.pagination.actualPage = page;
    data.pagination.first = first;
    data.pagination.last = last;
    return data;
  }
}